// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'

const baseURL = window.API_URL || 'https://fp-dev3.fkcore.org/api/v2'

const { jwt } = useJwt({
    loginEndpoint: `${baseURL}/auth/signin`,
    registerEndpoint: `${baseURL}/auth/signup`,
    changeEndpoint: `${baseURL}/auth/change-password`,
    resetEndpoint: `${baseURL}/auth/reset-password`,
    checkResetTokenEndpoint: `${baseURL}/auth/check-reset-token`,
    getUser: `${baseURL}/users`,
    refreshEndpoint: `${baseURL}/auth/token-refresh`,
    //logoutEndpoint: '/jwt/logout',

    // ** This will be prefixed in authorization header with token
    // ? e.g. Authorization: Bearer <token>
    tokenType: 'Bearer',

    // ** Value of this property will be used as key to store JWT token in storage
    storageTokenKeyName: 'accessToken',
    storageRefreshTokenKeyName: 'refreshToken'
})

export default jwt
